"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Divider_1 = require("../../atoms/Divider/Divider");
var Icon_1 = require("../../atoms/Icon/Icon");
var Link_1 = require("../../atoms/Link/Link");
var MenuItem_1 = require("../../atoms/MenuItem/MenuItem");
var Typography_1 = require("../../atoms/Typography/Typography");
var MenuSection_style_1 = __importDefault(require("./MenuSection.style"));
/**
 * MenuSection molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-menusection--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/MenuSection Source}
 */
var MenuSection = function (_a) {
    var items = _a.items, closeMenu = _a.closeMenu, className = _a.className, width = _a.width, title = _a.title, titleColor = _a.titleColor, divider = _a.divider, dividerMargin = _a.dividerMargin;
    var classes = (0, MenuSection_style_1.default)({ width: width || '100%' });
    var visibleItems = items.filter(function (item) { return !item.hidden; });
    function decorateItemClick(item) {
        return function () {
            var _a;
            !item.disableCloseOnClick && closeMenu();
            (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
        };
    }
    if (!visibleItems.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, className) }, { children: [divider ? (0, jsx_runtime_1.jsx)(Divider_1.Divider, { margin: dividerMargin }) : null, title ? renderTitle(title) : null, (0, jsx_runtime_1.jsx)("ul", { children: visibleItems.map(renderMenuItem) })] })));
    function renderMenuItem(item) {
        if (!item.url) {
            return ((0, jsx_runtime_1.jsx)(MenuItem_1.MenuItem, __assign({ onClick: decorateItemClick(item), className: 'hoverable', disabled: item.disabled, tooltip: item.tooltip }, { children: renderMenuItemContent(item) }), item.text));
        }
        return ((0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ fullWidth: true, url: item.url }, { children: (0, jsx_runtime_1.jsx)(MenuItem_1.MenuItem, __assign({ onClick: decorateItemClick(item), className: 'hoverable', tooltip: item.tooltip }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.menuItemLinkInner }, { children: renderMenuItemContent(item) })) })) }), item.text));
    }
    function renderMenuItemContent(item) {
        var itemColor = (function () {
            if (item.color) {
                return item.color;
            }
            if (item.alert) {
                return theme_1.default.textColors.error;
            }
            return theme_1.default.textColors.primary;
        })();
        var hoverVariant = (function () {
            if (item.tooltip && item.disabled) {
                return undefined;
            }
            return item.alert ? 'errorDark' : 'default';
        })();
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [item.icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: item.icon, color: itemColor, hoverVariant: hoverVariant }), (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: item.icon && classes.itemTextMarginLeft, variant: 'headline3', color: itemColor, hoverVariant: hoverVariant }, { children: item.text }))] }));
    }
    function renderTitle(text) {
        return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'headline2', bold: true, className: classes.title, color: titleColor }, { children: text })));
    }
};
exports.MenuSection = MenuSection;
